module.exports = __webpack_public_path__ + "static/media/29BDOS7.ea65d7d0.jpg";